import type { MaterialInfo } from '@rogue/rackbuilder'
import type { RackOptions } from '../../../../RackTypes'
import { RACK_COLORS } from '../../../../constants'
import { BaseMaterialStrategy } from './baseMaterialStrategy'

export class RMMaterialStrategy extends BaseMaterialStrategy {
  // backOverride must be resolved here rather than trusting this.config.back, which is the whole rack's type and can differ from this call's unit.
  createNameplateMaterials(nameplateOverride?: MaterialInfo, backOverride?: RackOptions['back']): MaterialInfo {
    const materials = JSON.parse(JSON.stringify(this.createMainMaterial())) as MaterialInfo
    const nameplate = nameplateOverride ?? this.config.materials?.nameplate
    const backSelection = backOverride ?? this.config.back

    if (backSelection === 'nameplate') {
    // Check for branding first (most specific)
      if (nameplate?.branding) {
        materials.main = nameplate.branding
      } else if (this.config.color === 'powdercoat' || this.config.color === '#333333' || this.config.color === '#1C1C1C') {
        materials.main = { name: 'metal', material: 'mg', color: RACK_COLORS['Rogue Red'] }
      }

      // Stainless uprights get stainless nameplate branding, but only if no explicit nameplate material was set
      if (this.config.stainlessUprights && !nameplate?.branding) {
        materials.main = { material: 'stainless' }
      }

      // MaterialInfo values may be arrays; branding never is, so the array branch is only a type narrowing.
      const branding = Array.isArray(nameplate?.branding) ? undefined : nameplate?.branding

      if (branding?.material === 'powdercoat') {
        materials.base = { material: 'powdercoat' }
      }
    }

    return materials
  }
  
  // backOverride/topCrossmemberOverride default to this.config.back/this.config.materials?.topCrossmember; backOverride must be resolved here since this.config.back is the whole rack's type, which can differ from this call's unit.
  createBackCrossmemberMaterials(backOverride?: RackOptions['back'], topCrossmemberOverride?: MaterialInfo): MaterialInfo {
    const backSelection = backOverride ?? this.config.back
    const topCrossmember = topCrossmemberOverride ?? this.config.materials?.topCrossmember

    // If explicitly set, use that
    if (backSelection === 'crossmember top 4' && topCrossmember) {
      return {
        main     : topCrossmember.main,
        hardware : { material: this.config.hardware },
      }
    }

    if (this.config.color === 'powdercoat' || this.config.color === 'stainless' || this.config.color === 'satinClear') {
      return {
        main     : { name: 'metal', material: this.config.color },
        hardware : { material: this.config.hardware },
      }
    }
    
    // Default rear crossmember materials
    return {
      main     : { material: 'mg', color: this.config.color },
      hardware : { material: this.config.hardware },
    }
  }
  
  createBackStabilizerMaterials(): MaterialInfo {
    if (this.config.color === 'powdercoat' || this.config.color === 'stainless' || this.config.color === 'satinClear') {
      return {
        main     : { name: 'metal', material: this.config.color },
        hardware : { material: this.config.hardware },
      }
    }
    
    // Default: MG with color
    return {
      main     : { name: 'metal', material: 'mg', color: this.config.color },
      hardware : { material: this.config.hardware },
    }
  }
}